document.addEventListener('DOMContentLoaded', () => {
    const sectionContent = document.querySelector('.gh-content');
    const figure = sectionContent.querySelector('figure:first-of-type');
    if (figure) {
        figure.remove();
    }
    const title = sectionContent.querySelector('h1:first-of-type');
    if (title) {
        title.remove();
    }
    const subtitle = sectionContent.querySelector('h5:first-of-type');
    if (subtitle) {
        subtitle.remove();
        const newTitle = document.createElement('h2'); // Create a new h2 element
        newTitle.innerHTML = subtitle.innerHTML; // Copy the content from the old title to the new title
        const newLocation = document.querySelector('.gh-article-meta'); // Select the new location
        newLocation.parentNode.insertBefore(newTitle, newLocation); // Append the new title to the new location
    }
});
